export const SET_SHARING_SORTING = 'SET_SHARING_SORTING';

export const setSharingsSorting = (newSorting) => ({
  type: SET_SHARING_SORTING,
  payload: newSorting,
});
